import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import NoticeTextInput from "components/complex/nationalNotice/components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "components/complex/nationalNotice/components/inputs/NoticeGlossaryInput";
import NoticeCpvInput from "components/complex/nationalNotice/components/inputs/NoticeCpvInput";
import NoticeIntegerInput from "components/complex/nationalNotice/components/inputs/NoticeIntegerInput";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeYesNoInput from "components/complex/nationalNotice/components/inputs/NoticeYesNoInput";
import NoticeNumericInput from "components/complex/nationalNotice/components/inputs/NoticeNumericInput";
import annulaReportClasses from "../../constants/annulaReportClasses";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import AnnualReportNoticeSource from "../../constants/AnnualReportNoticeSource";

function AnnualReportCommunityEditForm(
    {
        entry,
        newEntry,
        buttonWorks,
        reportStep,
        formikProps
    }) {
    const {getDict} = useContext(FormTranslationContext)
    const classes = annulaReportClasses();
    return (<>
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.type`}
                id="type"
                formikProps={formikProps}
                items={getDict("MP.MMiA.OrdersType").filter(item => item.value !== "DEFENSE_AND_SECURITY")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.number`}
                id="number"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks || entry.demandId != null}
            />
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.source`}
                id="source"
                formikProps={formikProps}
                items={getDict("MP.MMiA.Source")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.noticeNumber`}
                id="noticeNumber"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.serviceDescription`}
                id="serviceDescription"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeCpvInput
                label={`mmia.${reportStep}.codeCpv`}
                id="codeCpv"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <Collapse in={getObjectValue("source", formikProps.values) === AnnualReportNoticeSource.BZP}>
                <NoticeGlossaryInput
                    className={classes.exceptionChip}
                    label={`mmia.${reportStep}.tenderModeBzp`}
                    id="tenderModeBzp"
                    formikProps={formikProps}
                    items={getDict("ENUM.018_019_BZP")}
                    disabled={buttonWorks.anyWorks}
                />
            </Collapse>
            <Collapse in={getObjectValue("source", formikProps.values) === AnnualReportNoticeSource.TED}>
                <NoticeGlossaryInput
                    className={classes.exceptionChip}
                    label={`mmia.${reportStep}.tenderModeTed`}
                    id="tenderModeTed"
                    formikProps={formikProps}
                    items={getDict("ENUM.018_019_TED")}
                    disabled={buttonWorks.anyWorks}
                />
            </Collapse>
            <NoticeYesNoInput
                label={`mmia.${reportStep}.reservedTender`}
                id="reservedTender"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeNumericInput
                label={`mmia.${reportStep}.amount`}
                id="amount"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfAwardedLots`}
                id="numberOfAwardedLots"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfOffers`}
                id="numberOfOffers"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfOffersMMSP`}
                id="numberOfOffersMMSP"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
        </>
    )

}

AnnualReportCommunityEditForm.propTypes = {
    entry: PropTypes.object.isRequired,
    newEntry: PropTypes.bool,
    buttonWorks: PropTypes.shape({anyWorks: PropTypes.bool.isRequired}).isRequired,
    reportStep: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired
}

export default AnnualReportCommunityEditForm;